import { useQuery } from 'react-query'
import request from '../request'
import { EleadSubscription } from '../../lib/types/Elead/EleadSubscription'

export const useGetCDKFiSalesSubscriptions = () => {
  return useQuery<Array<EleadSubscription>>(
    ['admin', 'cdk', 'fi_sales', 'subscriptions'],
    ({ signal }) =>
      request({
        url: `/admin/cdk/fi_sales_subscriptions`,
        method: 'GET',
        signal,
      }).then((res: any) => res.data),
  )
}
